module.exports = __webpack_public_path__ + "img/logo-white.1582e82e.png";